import React from "react";

const Breadcrumb = ({ title, subtitle, actions, hideHeading = false }) => {
  if (hideHeading && !actions) {
    return null;
  }

  return (
    <div className="mb-24">
      <div className={`d-flex flex-wrap align-items-center gap-3 ${hideHeading ? 'justify-content-end' : 'justify-content-between'}`}>
        {!hideHeading && (
          <div className="flex-grow-1 min-w-0">
            <h1 className="fw-semibold mb-0 app-page-title">{title}</h1>
            {subtitle && (
              <p className="text-secondary-light text-sm mb-0 mt-1">{subtitle}</p>
            )}
          </div>
        )}
        {actions && (
          <div className="d-flex flex-wrap align-items-center gap-2 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default Breadcrumb;
